import styled from 'styled-components';

export const breakArea = styled.div`
    flex: 1;
    padding: 10px;
`;
